import Cookies from "js-cookie";
import { z } from "zod";

import {
  CookieName,
  FLOWSTEP_COOKIE_EXPIRATION_IN_DAYS,
} from "../cookies/cookies.constants.ts";

export const CookieConsentCategories = z.object({
  necessary: z.boolean(),
  analytics: z.boolean(),
  marketing: z.boolean(),
});
export type CookieConsentCategories = z.infer<typeof CookieConsentCategories>;

export const CookieConsentCategory = CookieConsentCategories.keyof();
export type CookieConsentCategory = z.infer<typeof CookieConsentCategory>;

const isServer = typeof window === "undefined";

const readCookieConsent = (): CookieConsentCategories | null => {
  if (isServer) return null;

  const cookieConsent = Cookies.get(CookieName.FlowstepCookiesConsent);

  try {
    const cookieConsentJson: unknown = cookieConsent
      ? JSON.parse(cookieConsent)
      : null;
    const parsedCookieConsent: CookieConsentCategories =
      CookieConsentCategories.parse(cookieConsentJson);
    return parsedCookieConsent;
  } catch {
    return null;
  }
};

export const needsCookieConsent = (): boolean => {
  const consent = readCookieConsent();
  return consent === null;
};

export const hasCookieConsentForCategory = (
  category: CookieConsentCategory,
) => {
  const consent = readCookieConsent();
  return consent?.[category] === true;
};

export const saveCookieConsent = (
  categories: CookieConsentCategories,
  domain: string,
) => {
  Cookies.set(CookieName.FlowstepCookiesConsent, JSON.stringify(categories), {
    expires: FLOWSTEP_COOKIE_EXPIRATION_IN_DAYS,
    secure: true,
    domain,
  });
};
